var parseUserAgent = require('./parseUserAgent.js');

var userAgent = '';
if (typeof navigator !== 'undefined') {
	userAgent = navigator.userAgent;
}

var referrer = '';
if (typeof document !== 'undefined') {
	referrer = document.referrer;
}

module.exports = parseUserAgent(userAgent, referrer);
